import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
import { testimonials } from '../data/testimonials';
import { InstructorBenefits } from './InstructorBenefits';
export function TestimonialsStrip() {
  if (testimonials.length === 0) return <InstructorBenefits data-id="element-317" data-mp="3ss4up5tjb1hk" />;
  return <section className="py-12 bg-[#F2F7F8] border-y border-slate-200" data-id="element-318" data-mp="3nz21wzwkzw2f">
      <div className="max-w-7xl mx-auto px-4" data-id="element-319" data-mp="5lm0nhy9ryth">
        <div className="text-center mb-7" data-id="element-320" data-mp="5kawvi4tqr2d">
          <h2 className="text-[#0F4C5C] font-bold tracking-widest uppercase text-sm" data-id="element-321" data-mp="5nf992sg0t44">
            What Dental Instructors Are Saying
          </h2>
        </div>
        <div className="grid md:grid-cols-3 gap-6" data-id="element-322" data-mp="figu3mfor90w">
          {testimonials.map((testimonial, index) => <motion.article key={testimonial.name} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          delay: index * 0.05,
          ease: [0.23, 1, 0.32, 1]
        }} className="bg-white border border-slate-200 p-6 rounded-2xl shadow-sm shadow-[#0F4C5C]/5 flex flex-col" data-id="element-323" data-mp="al8g7y1klr5g" data-mpi={index}>
              <div className="flex gap-1 text-amber-500 mb-4" aria-label="5 out of 5 stars" data-id="element-324" data-mp="gby8qnoruj4m">
                {[...Array(5)].map((_, starIndex) => <Star key={starIndex} size={16} fill="currentColor" aria-hidden="true" data-id="element-325" data-mp="q55mowxkv7gb" data-mpi={starIndex} />)}
              </div>
              <p className="text-slate-700 italic mb-6 text-sm leading-relaxed" data-id="element-326" data-mp="v2xgxxlp35no">
                “{testimonial.text}”
              </p>
              <div className="mt-auto pt-4 border-t border-slate-200" data-id="element-327" data-mp="14451zdz7a9zt">
                <div className="font-bold text-[#0F4C5C] text-sm" data-id="element-328" data-mp="141skt319o3nt">{testimonial.name}</div>
                {testimonial.role && <div className="text-xs text-[#0A6464] font-semibold mt-0.5" data-id="element-329" data-mp="35vi4xxhly7t8">{testimonial.role}</div>}
                <div className="flex items-center gap-1.5 text-xs text-slate-500 mt-1.5" data-id="element-330" data-mp="3atjpynylgh7c">
                  <img src={`https://flagcdn.com/${testimonial.countryCode}.svg`} alt="" aria-hidden="true" className="w-[18px] h-[13px] rounded-[2px] object-cover shrink-0 ring-1 ring-black/5" data-id="element-331" data-mp="hz2y9feprs80" />
                  {testimonial.country}
                </div>
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}